import { APP_NAME, WEBUI_URL } from "@/configs";
import Head from "next/head";

export const HeadNextJs = ({
  title,
  viewport = "width=device-width, initial-scale=1, shrink-to-fit=no",
  description = "",
  charset = "text/html; charset=utf-8",
  robots = "index",
  url = WEBUI_URL,
  image = "/Sellpath-logo.png"
}: {
  title: string;
  viewport?: string;
  description?: string;
  charset?: string;
  robots?: string;
  url?: string;
  image?: string;
}) => {
  return (
    <Head>
      {/* title */}
      <title>{title.slice(0, 1).toUpperCase() + title.slice(1) + " - " + APP_NAME}</title>
      <link rel="shortcut icon" href="/Sellpath-logo.png" />
      {/* title */}
      <meta name="viewport" content={viewport} />
      <meta name="description" content={description} />
      <meta httpEquiv="Content-Type" content={charset} />
      <meta name="robots" content={robots} />
      {/* title */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url ? url : WEBUI_URL} />
      <meta property="og:title" content={APP_NAME + " " + title.slice(0, 1).toUpperCase() + title.slice(1)} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
    </Head>
  );
};
